import React from 'react';
import PropTypes from 'prop-types';
import TableCellContextMenu from '../../../../../shared/components/table/TableCellContextMenu';
import Hook from '../../../../../shared/hooks';

const ActionCell = ({ record }) => {
  const [showModal] = Hook.useShowModalHook('SuccessModal');

  const handleShowSponsors = () => {
    const sponsorNames = record.params?.aiApprovalsData?.sponsorNames;
    const message = (
      <div className="ltr-support theme-light">
        <ul>
          {sponsorNames
            ? sponsorNames.split(',').map((sponsor, index) => (
              <li key={`sponsor_${index}`}>
                {sponsor.trim()}
              </li>
            ))
            : <li>No sponsors found.</li>}
        </ul>
      </div>
    );
    showModal({ title: 'Sponsors Details', message, width: '300px' });
  };

  const options = [
    {
      label: 'Last 10 Sponsored',
      handler: handleShowSponsors,
    },
  ];

  return (
    <div style={{ paddingTop: '8px' }}>
      <TableCellContextMenu options={options} />
    </div>
  );
};

ActionCell.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ActionCell;
